/**
 * Utility functions for converting time range filter values
 */

/**
 * Mapping of predefined time range values to hours
 * Used by convertTimeRangeToDashboardFilters
 */
const TIME_RANGE_TO_HOURS = {
  last_1h: 1,
  last_24h: 24,
  last_7d: 24 * 7,
  last_30d: 24 * 30,
  last_90d: 24 * 90,
  last_365d: 24 * 365,
};

/**
 * Convert TimeRangeFilter value to dashboard filter format
 * @param {Object} timeRangeValue - Value from TimeRangeFilter component
 * @returns {Object} - { timeFrom, timeTo } as Unix timestamps (seconds)
 */
export function convertTimeRangeToDashboardFilters(timeRangeValue) {
  if (!timeRangeValue) {
    return { timeFrom: null, timeTo: null };
  }

  const { mode, range, start, end } = timeRangeValue;

  // Handle custom range mode
  if (mode === 'custom') {
    if (start && end) {
      return {
        timeFrom: Math.floor(new Date(start).getTime() / 1000),
        timeTo: Math.floor(new Date(end).getTime() / 1000),
      };
    }
    return { timeFrom: null, timeTo: null };
  }

  // Handle predefined range mode
  if (mode === 'predefined' && range) {
    const hours = TIME_RANGE_TO_HOURS[range] || 24 * 7; // Default to 7 days
    const now = new Date();
    const from = new Date(now.getTime() - (hours * 60 * 60 * 1000));

    return {
      timeFrom: Math.floor(from.getTime() / 1000),
      timeTo: Math.floor(now.getTime() / 1000),
    };
  }

  // Fallback
  return { timeFrom: null, timeTo: null };
}

/**
 * Get the default time range filter value
 * @returns {Object} - Default TimeRangeFilter value
 */
export function getDefaultTimeRangeValue() {
  return {
    mode: 'predefined',
    range: 'last_7d',
    start: null,
    end: null,
    timezone: 'local',
  };
}

